import { isObject } from "@gr-common/async/tools";
import type { NavigationState, StateManaged, StateRecord } from "./state.types.js";
import { NAV_META, NAV_SCOPES, type ObjectToEntries } from "../lib/utils.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const sanitizeState = (state: unknown): StateManaged => {
  /*                                                                       */
  const stateObject = { ...(isObject(state) ? (state as Partial<StateManaged>) : {}) };
  stateObject[NAV_META] = { ...stateObject[NAV_META] };
  stateObject[NAV_SCOPES] = { ...stateObject[NAV_SCOPES] };
  return stateObject as StateManaged;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const sanitizeIncommingState = (
  current: unknown,
  next: unknown,
  clean: boolean | undefined,
): StateManaged => {
  const result = sanitizeState(next);

  /*                                            */
  if (clean) return result;

  /*                                                                      */
  const cur = sanitizeState(current);
  Object.assign(cur[NAV_META], result[NAV_META]);
  Object.assign(cur[NAV_SCOPES], result[NAV_SCOPES]);

  return result;
};

export const locationState = <T extends StateRecord>(state: T = {} as T): NavigationState<T> => {
  const raw = new Map<keyof T, unknown>(Object.entries(state as StateRecord));

  const res: NavigationState<T> = {
    get [Symbol.toStringTag]() {
      return `NavigationState`;
    },
    get empty() {
      return raw.size === 0;
    },
    [Symbol.iterator]: raw[Symbol.iterator].bind(raw) as never,
    clear: raw.clear.bind(raw) as never,
    has: raw.has.bind(raw) as never,
    get: (...a: [string, unknown?]) => {
      const resVal = raw.has(a[0]) ? raw.get(a[0]) : undefined;
      return (resVal === undefined ? a[1] : resVal) as never;
    },
    set: raw.set.bind(raw) as never,
    delete: raw.delete.bind(raw) as never,
    values: raw.values.bind(raw) as never,
    keys: raw.keys.bind(raw) as never,
    forEach: raw.forEach.bind(raw) as never,
    entries: raw.entries.bind(raw) as never,
    /*                       */

    toEntries: () => [...raw] as ObjectToEntries<T>,
    fromEntries(entries) {
      raw.clear();
      for (const [key, value] of entries) raw.set(key, value);
    },

    /*                                */
    toObject: () => Object.fromEntries([...raw]) as never,
    fromObject(data) {
      raw.clear();
      for (const [key, value] of Object.entries(data)) raw.set(key, value);
    },
    clone: () => locationState(res.toObject()),

    /*              */
    setMany(partial: Partial<T>) {
      for (const [key, value] of Object.entries(partial)) raw.set(key, value);
    },

    /*                  */
    parse: (schema, params) => schema.parse(res.toObject(), params),
    parseSafe: (schema, params) => schema.safeParse(res.toObject(), params),
  };

  return res;
};
